const NEW = 'NEW';
const SENT = 'SENT';
const DELIVERED = 'DELIVERED';
const UNDELIVERED = 'UNDELIVERED';

export { NEW, SENT, DELIVERED, UNDELIVERED };
